import { render, staticRenderFns } from "./BaseTrumpetAdd.vue?vue&type=template&id=1ac1aa06&scoped=true"
import script from "./BaseTrumpetAdd.vue?vue&type=script&lang=js"
export * from "./BaseTrumpetAdd.vue?vue&type=script&lang=js"
import style0 from "./BaseTrumpetAdd.vue?vue&type=style&index=0&id=1ac1aa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1aa06",
  null
  
)

export default component.exports